"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IEquipmentTypeOrAll = void 0;
var IEquipmentTypeOrAll;
(function (IEquipmentTypeOrAll) {
    IEquipmentTypeOrAll["App"] = "App";
    IEquipmentTypeOrAll["Bike"] = "Bike";
    IEquipmentTypeOrAll["Elliptical"] = "Elliptical";
    IEquipmentTypeOrAll["Equipmentless"] = "Equipmentless";
    IEquipmentTypeOrAll["FreeStrider"] = "FreeStrider";
    IEquipmentTypeOrAll["Fusion"] = "Fusion";
    IEquipmentTypeOrAll["InclineTrainer"] = "Incline Trainer";
    IEquipmentTypeOrAll["Mirror"] = "Mirror";
    IEquipmentTypeOrAll["None"] = "None";
    IEquipmentTypeOrAll["Rower"] = "Rower";
    IEquipmentTypeOrAll["Shoes"] = "Shoes";
    IEquipmentTypeOrAll["SpinBike"] = "SpinBike";
    IEquipmentTypeOrAll["StationaryBike"] = "Stationary Bike";
    IEquipmentTypeOrAll["Stepper"] = "Stepper";
    IEquipmentTypeOrAll["Strength"] = "Strength";
    IEquipmentTypeOrAll["Strider"] = "Strider";
    IEquipmentTypeOrAll["StudioBike"] = "Studio Bike";
    IEquipmentTypeOrAll["TDFBike"] = "TDF Bike";
    IEquipmentTypeOrAll["Treadmill"] = "Treadmill";
    IEquipmentTypeOrAll["Vault"] = "Vault";
    IEquipmentTypeOrAll["VerticalElliptical"] = "VerticalElliptical";
    IEquipmentTypeOrAll["VibrationPlatform"] = "Vibration Platform";
    IEquipmentTypeOrAll["Wearable"] = "wearable";
    IEquipmentTypeOrAll["All"] = "all";
})(IEquipmentTypeOrAll || (exports.IEquipmentTypeOrAll = IEquipmentTypeOrAll = {}));
//# sourceMappingURL=equipment-type-or-all.js.map